import { css } from '@emotion/react';

export const roundedFull = css({ borderRadius: '9999px' });

export const rounded3xl = css({ borderRadius: '1.5rem' });

export const rounded2xl = css({ borderRadius: '1rem' });

export const roundedXl = css({ borderRadius: '0.75rem' });

export const roundedLg = css({ borderRadius: '0.5rem' });

export const roundedMd = css({ borderRadius: '0.25rem' });

export const roundedSm = css({ borderRadius: '0.125rem' });
